import { 
  Star, 
  Crown, 
  MessageCircle, 
  DollarSign, 
  Handshake, 
  Frown, 
  Wrench, 
  Package, 
  Building, 
  CreditCard, 
  Gift, 
  Users, 
  Phone, 
  Megaphone,
  UserPlus,
  RotateCcw,
  TrendingUp,
  Zap,
  Calendar,
  RotateCw,
  Award,
  Clock,
  Timer,
  AlertTriangle,
  AlertCircle,
  Sun,
  Sunset,
  Moon,
  Coffee,
  Cake,
  Heart,
  Calendar as CalendarIcon
} from 'lucide-react';

// Manual tag definitions with Turkish labels and styling
export const MANUAL_TAG_CONFIG = {
  vip: {
    label: 'VIP Müşteri',
    description: 'Özel hizmet gerektiren değerli müşteri',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    icon: Crown,
    category: 'status'
  },
  sadik: {
    label: 'Sadık Müşteri',
    description: 'Uzun süreli ve sadık müşteri',
    color: 'bg-blue-100 text-blue-800 border-blue-200',
    icon: Star,
    category: 'loyalty'
  },
  sik_soran: {
    label: 'Sık Soru Soran',
    description: 'Detaylı bilgi isteyen müşteri',
    color: 'bg-purple-100 text-purple-800 border-purple-200',
    icon: MessageCircle,
    category: 'behavior'
  },
  fiyat_duyarli: {
    label: 'Fiyat Duyarlı',
    description: 'Fiyatlara karşı hassas müşteri',
    color: 'bg-orange-100 text-orange-800 border-orange-200',
    icon: DollarSign,
    category: 'behavior'
  },
  pazarlikci: {
    label: 'Pazarlıkçı',
    description: 'Pazarlık yapmayı seven müşteri',
    color: 'bg-green-100 text-green-800 border-green-200',
    icon: Handshake,
    category: 'behavior'
  },
  memnuniyetsiz_gecmis: {
    label: 'Geçmişte Memnuniyetsiz',
    description: 'Önceden yaşanan sorunlar',
    color: 'bg-red-100 text-red-800 border-red-200',
    icon: Frown,
    category: 'attention'
  },
  servis_bekliyor: {
    label: 'Servis Bekliyor',
    description: 'Servis hizmeti bekleniyor',
    color: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    icon: Wrench,
    category: 'service'
  },
  montaj_bekliyor: {
    label: 'Montaj Bekliyor',
    description: 'Montaj hizmeti bekleniyor',
    color: 'bg-cyan-100 text-cyan-800 border-cyan-200',
    icon: Package,
    category: 'service'
  },
  kurumsal: {
    label: 'Kurumsal Müşteri',
    description: 'Şirket/kurum müşterisi',
    color: 'bg-slate-100 text-slate-800 border-slate-200',
    icon: Building,
    category: 'type'
  },
  taksit_agirlikli: {
    label: 'Taksitli Alım',
    description: 'Taksitli ödemeyi tercih eder',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    icon: CreditCard,
    category: 'payment'
  },
  aksesuar_odakli: {
    label: 'Aksesuar Odaklı',
    description: 'Aksesuar ürünlere ilgi duyar',
    color: 'bg-pink-100 text-pink-800 border-pink-200',
    icon: Gift,
    category: 'interest'
  },
  yakini_es_dost: {
    label: 'Yakın/Eş-Dost',
    description: 'Personel yakını veya arkadaşı',
    color: 'bg-rose-100 text-rose-800 border-rose-200',
    icon: Users,
    category: 'relation'
  },
  geri_aransin: {
    label: 'Geri Aransın',
    description: 'Aranması gereken müşteri',
    color: 'bg-amber-100 text-amber-800 border-amber-200',
    icon: Phone,
    category: 'action'
  },
  kampanya_ilgili: {
    label: 'Kampanya İlgilisi',
    description: 'Kampanya ve indirimleri takip eder',
    color: 'bg-violet-100 text-violet-800 border-violet-200',
    icon: Megaphone,
    category: 'interest'
  }
} as const;

// Auto tag definitions with Turkish labels and styling
export const AUTO_TAG_CONFIG = {
  yeni_musteri: {
    label: 'Yeni Müşteri',
    description: 'Kısa süre önce kaydolan müşteri',
    color: 'bg-green-50 text-green-700 border-green-100',
    icon: UserPlus,
    category: 'lifecycle'
  },
  geri_donen: {
    label: 'Geri Dönen',
    description: 'Uzun süre sonra tekrar gelen müşteri',
    color: 'bg-blue-50 text-blue-700 border-blue-100',
    icon: RotateCcw,
    category: 'lifecycle'
  },
  sik_gelen: {
    label: 'Sık Gelen',
    description: 'Düzenli olarak gelen müşteri',
    color: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    icon: TrendingUp,
    category: 'frequency'
  },
  cok_sik_gelen: {
    label: 'Çok Sık Gelen',
    description: 'Çok sık gelen müşteri',
    color: 'bg-teal-50 text-teal-700 border-teal-100',
    icon: Zap,
    category: 'frequency'
  },
  haftalik_aktif: {
    label: 'Haftalık Aktif',
    description: 'Her hafta düzenli gelen müşteri',
    color: 'bg-indigo-50 text-indigo-700 border-indigo-100',
    icon: Calendar,
    category: 'frequency'
  },
  tekrar_aynigun: {
    label: 'Aynı Gün Tekrar',
    description: 'Aynı gün içinde tekrar gelen müşteri',
    color: 'bg-purple-50 text-purple-700 border-purple-100',
    icon: RotateCw,
    category: 'behavior'
  },
  geri_kazanildi: {
    label: 'Geri Kazanıldı',
    description: 'Kaybedildikten sonra geri kazanılan müşteri',
    color: 'bg-orange-50 text-orange-700 border-orange-100',
    icon: Award,
    category: 'lifecycle'
  },
  kisa_ziyaret: {
    label: 'Kısa Ziyaret',
    description: 'Kısa süreli ziyaretler yapan müşteri',
    color: 'bg-yellow-50 text-yellow-700 border-yellow-100',
    icon: Clock,
    category: 'visit_pattern'
  },
  uzun_ziyaret: {
    label: 'Uzun Ziyaret',
    description: 'Uzun süreli ziyaretler yapan müşteri',
    color: 'bg-cyan-50 text-cyan-700 border-cyan-100',
    icon: Timer,
    category: 'visit_pattern'
  },
  cok_uzun_ziyaret: {
    label: 'Çok Uzun Ziyaret',
    description: 'Çok uzun süreli ziyaretler yapan müşteri',
    color: 'bg-rose-50 text-rose-700 border-rose-100',
    icon: Timer,
    category: 'visit_pattern'
  },
  beklemede_cikis_yok: {
    label: 'Beklemede Çıkış Yok',
    description: 'Çıkış kaydı olmayan ziyaret',
    color: 'bg-red-50 text-red-700 border-red-100',
    icon: AlertTriangle,
    category: 'attention'
  },
  kayip_riski: {
    label: 'Kayıp Riski',
    description: 'Kaybedilme riski olan müşteri',
    color: 'bg-amber-50 text-amber-700 border-amber-100',
    icon: AlertCircle,
    category: 'risk'
  },
  cok_kayip_riski: {
    label: 'Yüksek Kayıp Riski',
    description: 'Yüksek kaybedilme riski olan müşteri',
    color: 'bg-red-50 text-red-700 border-red-100',
    icon: AlertCircle,
    category: 'risk'
  },
  sabahci: {
    label: 'Sabahçı',
    description: 'Sabah saatlerinde gelen müşteri',
    color: 'bg-sky-50 text-sky-700 border-sky-100',
    icon: Sun,
    category: 'time_preference'
  },
  ogleci: {
    label: 'Öğleci',
    description: 'Öğle saatlerinde gelen müşteri',
    color: 'bg-yellow-50 text-yellow-700 border-yellow-100',
    icon: Sun,
    category: 'time_preference'
  },
  aksamci: {
    label: 'Akşamcı',
    description: 'Akşam saatlerinde gelen müşteri',
    color: 'bg-orange-50 text-orange-700 border-orange-100',
    icon: Sunset,
    category: 'time_preference'
  },
  gececi: {
    label: 'Gececi',
    description: 'Gece saatlerinde gelen müşteri',
    color: 'bg-slate-50 text-slate-700 border-slate-100',
    icon: Moon,
    category: 'time_preference'
  },
  dogumgunu_yaklasiyor: {
    label: 'Doğum Günü Yaklaşıyor',
    description: 'Doğum günü yaklaşan müşteri',
    color: 'bg-pink-50 text-pink-700 border-pink-100',
    icon: Cake,
    category: 'special_dates'
  },
  yildonumu_yaklasiyor: {
    label: 'Yıl Dönümü Yaklaşıyor',
    description: 'Yıl dönümü yaklaşan müşteri',
    color: 'bg-red-50 text-red-700 border-red-100',
    icon: Heart,
    category: 'special_dates'
  },
  hafta_ici_musterisi: {
    label: 'Hafta İçi Müşterisi',
    description: 'Hafta içi gelen müşteri',
    color: 'bg-indigo-50 text-indigo-700 border-indigo-100',
    icon: CalendarIcon,
    category: 'day_preference'
  },
  hafta_sonu_musterisi: {
    label: 'Hafta Sonu Müşterisi',
    description: 'Hafta sonu gelen müşteri',
    color: 'bg-violet-50 text-violet-700 border-violet-100',
    icon: CalendarIcon,
    category: 'day_preference'
  }
} as const;

// Tag categories for better organization
export const TAG_CATEGORIES = {
  status: 'Durum',
  loyalty: 'Sadakat',
  behavior: 'Davranış',
  attention: 'Dikkat',
  service: 'Hizmet',
  type: 'Tür',
  payment: 'Ödeme',
  interest: 'İlgi Alanı',
  relation: 'İlişki',
  action: 'Aksiyon',
  lifecycle: 'Müşteri Döngüsü',
  frequency: 'Sıklık',
  visit_pattern: 'Ziyaret Deseni',
  risk: 'Risk',
  time_preference: 'Zaman Tercihi',
  special_dates: 'Özel Tarihler',
  day_preference: 'Gün Tercihi'
} as const;

// Helper functions
export const getTagConfig = (tag: string, isManual: boolean = true) => {
  if (isManual) {
    return MANUAL_TAG_CONFIG[tag as keyof typeof MANUAL_TAG_CONFIG];
  }
  return AUTO_TAG_CONFIG[tag as keyof typeof AUTO_TAG_CONFIG];
};

export const formatTagLabel = (tag: string, isManual: boolean = true) => {
  const config = getTagConfig(tag, isManual);
  return config?.label || tag.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

export const getTagsByCategory = (tags: string[], isManual: boolean = true) => {
  const tagConfig = isManual ? MANUAL_TAG_CONFIG : AUTO_TAG_CONFIG;
  const categorized: Record<string, Array<{ tag: string; config: any }>> = {};
  
  tags.forEach(tag => {
    const config = tagConfig[tag as keyof typeof tagConfig];
    if (config) {
      const category = config.category;
      if (!categorized[category]) {
        categorized[category] = [];
      }
      categorized[category].push({ tag, config });
    }
  });
  
  return categorized;
};
